<template lang="html">
  <Row :gutter="15">
    <Col :span="24">
    <Card class="card-box">
      <div slot="header">
        Tracking
      </div>
      <div class="text-center" v-if="isTrackingLoading">
        <Spinner />
      </div>
      <div class="status-msg" v-else-if="!trackingDetails">
        <span>
          <svgicon :name="emptyDashboardIcon" width="150" height="115" :original="true" />
          <p class="mt-0 ml-30">No data available</p>
        </span>
      </div>
      <Row :gutter="40" class="list-bordered" v-else>
        <Col :span="4" v-for="header in trackingHeaders" :key="header.id" :class="header.class">
        <Tooltip :open-delay="100" popper-class="max-width" effect="dark" placement="top">
          <div slot="content">
            <span v-html="trackingDashboard[header.column]"></span>
          </div>
          <ColCell :header="header" :value="trackingDetails[header.column]"
            @routeToTrack="$emit('routeToTrack', { routeCategory: header.routeCategory, header: $event })">
          </ColCell>
        </Tooltip>
        </Col>
      </Row>
    </Card>
    </Col>
  </Row>
</template>

<script>
import ColCell from '@/components/track/ColCell';
import Graph from '@/components/track/Graph';
import {
  filters,
  etaDetailsHeaders,
  etaBarChartConstants,
  trackingHeaders,
} from '@/constants/trackConstants';
import SecFilterMixin from '@common/mixins/SecFilterMixin';

export default {
  components: {
    ColCell,
    Graph,
  },
  mixins: [SecFilterMixin],
  async created() {
    this.apiTrigger.$on('loadMore', (args) => {
      this.search();
    });
  },
  data() {
    return {
      filters,
      etaBarChartConstants,
      etaDetailsHeaders,
      etaCompliance: null,
      trackDetailsArray: [],
      trackingHeaders,
      isTrackingLoading: true,
    };
  },
  props: ['queryParams', 'apiTrigger', 'emptyDashboardIcon', 'trackingDashboard'],
  computed: {
    trackingDetails() {
      let trackingDetails = null;
      if (this.trackDetailsArray && this.trackDetailsArray.length) {
        const simDetails = this.trackDetailsArray.find(val => val.type === 'SIM');
        const appDetails = this.trackDetailsArray.find(val => val.type === 'APP');
        const gpsDetails = this.trackDetailsArray.find(val => val.type === 'GPS');
        if (simDetails) {
          trackingDetails = {
            sim: simDetails.count,
            tracked: simDetails.tracked,
            nontrackable: simDetails.nontrackable,
            simNoPings: simDetails.no_pings,
          };
        }
        if (appDetails) {
          trackingDetails = Object.assign(trackingDetails, {
            app: appDetails.count,
            appNoPings: appDetails.no_pings,
          });
        }
        if (gpsDetails) {
          trackingDetails = Object.assign(trackingDetails, {
            gps: gpsDetails.count,
            gpsNoPings: gpsDetails.no_pings,
          });
        }
      }
      return trackingDetails;
    },
  },
  methods: {
    async search() {
      const resultObj = 'trackDetailsArray';
      const loadingObj = 'isTrackingLoading';
      const section = 'trackingDetails';
      const params = this.queryParams;
      this[loadingObj] = true;
      const result = await this.$store.dispatch('track/getDashboardDetails', { section, params });
      if (result && !result.error) {
        this[resultObj] = result;
      } else {
        this[resultObj] = null;
      }
      this[loadingObj] = false;
    },
  },
};
</script>
